import Lenis from 'lenis';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

let lenisInstance = null;
let rafHandler = null;
let noScrollObserver = null;

function shouldStopLenis() {
    return (
        document.body.classList.contains('no-scroll') ||
        document.body.classList.contains('modal-open')
    );
}

function syncLenisWithNoScroll() {
    if (!lenisInstance) return;
    if (shouldStopLenis() && typeof lenisInstance.stop === 'function') {
        lenisInstance.stop();
    } else if (!shouldStopLenis() && typeof lenisInstance.start === 'function') {
        lenisInstance.start();
    }
}

function observeNoScroll() {
    if (noScrollObserver) return;
    syncLenisWithNoScroll();
    noScrollObserver = new MutationObserver(syncLenisWithNoScroll);
    noScrollObserver.observe(document.body, {
        attributes: true,
        attributeFilter: ['class'],
    });
}

function initLenis() {
    if (lenisInstance) {
        lenisInstance.resize();
        syncLenisWithNoScroll();
        return lenisInstance;
    }

    const lenis = new Lenis({
        autoRaf: false,
        lerp: 0.08,
        smoothWheel: true,
        smoothTouch: true,
        wheelMultiplier: 0.6,
        touchMultiplier: 0.7,
        anchors: true,
    });

    lenis.on('scroll', ScrollTrigger.update);

    rafHandler = (time) => {
        lenis.raf(time * 1000);
    };
    gsap.ticker.add(rafHandler);
    gsap.ticker.lagSmoothing(0);

    lenisInstance = lenis;
    window.__lenis = lenis;

    observeNoScroll();
    return lenisInstance;
}

function destroyLenis() {
    if (noScrollObserver) {
        noScrollObserver.disconnect();
        noScrollObserver = null;
    }
    if (!lenisInstance) return;
    lenisInstance.destroy();
    lenisInstance = null;
    if (window.__lenis) {
        delete window.__lenis;
    }
    if (rafHandler) {
        gsap.ticker.remove(rafHandler);
        rafHandler = null;
    }
}

export { initLenis, destroyLenis };
